var _polygon, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlatbedtruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.8,13.4 1,14 8.5,14 8.5,12.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "11.6,5.9 11.6,11.2 10.7,12.4 10.7,14 12,14 12,5.9  "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,14.4c0,0.5,0.4,0.5,0.4,0.5v1.4h-1.3C21.6,14,19.6,14,19.6,14c-2,0-2.2,2.2-2.2,2.2H9.3 c0.1-1.5-1.1-1.8-1.1-1.8h4.3V7h4.3l1.1,3.5l4.8,0.4V14.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "17.5,10.7 14.3,10.7 14.3,7.8 16.6,7.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "14.9,12.4 14.6,12.6 14.3,12.4 14.3,11.8 14.6,11.5 14.9,11.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "18.8,11.8 18.8,13.2 19.2,13.4 19.4,13.2 19.4,11.8 19.1,11.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "19.7,11.8 19.7,13.2 20,13.4 20.3,13.2 20.3,11.8 20,11.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "20.5,11.8 20.5,13.2 20.8,13.4 21.1,13.2 21.1,11.8 20.8,11.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "13.6,15.7 16.5,15.7 16.8,15.4 16.5,15.1 13.7,15.1 13.4,15.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.5,16.2c0,1,0.8,1.8,1.8,1.8S5,17.2,5,16.2s-0.8-1.8-1.8-1.8C2.3,14.4,1.5,15.2,1.5,16.2z M2.8,16.2 C2.8,16.2,2.8,16.2,2.8,16.2c0-0.4,0.3-0.5,0.5-0.5s0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.3,0-0.4-0.1C2.8,16.5,2.8,16.4,2.8,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.4,16.2c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8S5.4,15.2,5.4,16.2z M6.6,16.2 C6.6,16.2,6.6,16.2,6.6,16.2c0-0.4,0.3-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1C6.7,16.5,6.6,16.4,6.6,16.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,15.3c-0.2-0.2-0.7-0.8-0.7-0.8H6C5.8,14.7,5.2,15.3,5.2,15.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2,14.5C1.4,14.7,1,15.8,1,15.8v-1.3C1,14.5,2.2,14.5,2.2,14.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.8,16.2c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8S17.8,15.2,17.8,16.2z M19,16.2 C19,16.2,19,16.2,19,16.2c0-0.4,0.3-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1C19.1,16.5,19,16.4,19,16.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatbedtruck);
export default __webpack_public_path__ + "static/media/flatbedtruck.b2be174593a6dc394b13114b5979d8d8.svg";
export { ForwardRef as ReactComponent };